import React, { useState, setState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, Box, Grid, TextField, FormLabel, FormControl, FormGroup, FormControlLabel, FormHelperText, Checkbox, Paper, Typography, Button, Snackbar } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom'
// import { MenuIcon } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';

import { useDispatch, useSelector } from 'react-redux';
import {
    setName,
    clearName,
    setMail,
    clearMail,
    setTelephone,
    clearTelephone,
    setAddress,
    clearAddress,
    setMemo,
    clearMemo,
    setTelephoneRequest,
    clearTelephoneRequest,
    setMailRequest,
    clearMailRequest
} from '../stores/author'
import {
    setIgonFlag,
} from '../stores/igon'

import MenuList from './MenuList' // メニュー
import GuideHalf from './GuideHalf' // ガイド

import FlowTitle from './FlowTitle' // フロータイトル
import FlowItem from './FlowItem' // フローアイテム
import FlowItemA from './FlowItemA' // フローアイテム
import FlowItemB from './FlowItemB' // フローアイテム
import FlowArrow from './FlowArrow' // フローアロー
import FlowCaution from './FlowCaution' // フロー注意

import PageExplanation from './PageExplanation' // ページ説明

import PageStep from './PageStep' // ステップ
import PersonStep from './PersonStep' // 個人情報ステップ

const useStyles = makeStyles((theme) => ({
    menu: {
        marginTop: '1rem',
    },
    explanation: {
        marginTop: '1rem',
        padding: '.5rem'
    },
    icon: {
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '5px',
        border: '2px solid #fff',
        fontSize: '1.3em',
        fontWeight: 'bold',
        margin: '0 5px'
    },
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    },
}));

function AuthorWill(){
    const dispatch = useDispatch();

    const igonFlag = true;

    const history = useHistory();

    const name = useSelector(state => state.author.name);
    const mail = useSelector(state => state.author.mail);
    const telephone = useSelector(state => state.author.telephone);
    const address = useSelector(state => state.author.address);
    const memo = useSelector(state => state.author.memo);
    const telephoneRequest = useSelector(state => Boolean(state.author.telephoneRequest));
    const mailRequest = useSelector(state => Boolean(state.author.mailRequest));
    const state = useSelector(state => state);

    const [alert, setAlert] = useState(false);
    const [error, setError] = useState(null);

    const alertClose = () => {
        setAlert(false);
    }

    const handleAuthor = (event) => {
         const authorName = document.getElementById('author_name').value;
         const authorMail = document.getElementById('author_mail').value;
         const authorTel = document.getElementById('author_tel').value;

         if(authorName == ''){
            checkName(true);
            nameHelper('お名前は必ずご入力くさだい。');
            setError('エラーが発生しました。お名前は必ずご入力くさだい。');
            setAlert(true);
            return;
         }else if(authorMail == ''){
            checkMail(true);
            mailHelper('メールアドレスは必ずご入力くさだい。');
            setError('エラーが発生しました。メールアドレスは必ずご入力くさだい。');
            setAlert(true);
            return;
         }else if(authorTel == ''){
            checkTelephone(true);
            telHelper('電話番号は必ずご入力くさだい。');
            setError('エラーが発生しました。電話番号は必ずご入力くさだい。');
            setAlert(true);
            return;
         }else{
//
//             const data = {
//                 'author': state.author,
//                 'action': 'create'
//             };
//
//             fetch('http://xs974553.xsrv.jp/sample/create_pdf.php', {
//             // fetch('http://192.168.33.10/igon-sozoku/mail_send.php', {
//                 'method': 'POST',
//                 'body': JSON.stringify(data),
//             }).then(response => {
//                 if(response.ok){
//                 }else{
//                     return Promise.reject(new Error('システムエラー'));
//                 }
//             }).catch(e => {
//                 console.log(e.message);
//             });
//
            dispatch(setIgonFlag(true));

            history.push('/testament');
         }

    }

    const redirectMoney = (event) => {
        dispatch(setIgonFlag(true));
        history.push('/money');
    }

    const [nameHelperText, nameHelper] = useState('必須');
    const [mailHelperText, mailHelper] = useState('必須');
    const [telHelperText, telHelper] = useState('必須');

    const [nameValidate, checkName] = useState(false);
    const handleName = (event) => {
        if(event.target.value){
            checkName(false);
            nameHelper('必須');
            dispatch(setName(event.target.value));
        }else{
            checkName(true);
            nameHelper('お名前は必ずご入力くさだい。');
            dispatch(clearName());
        }
    }

    const [mailValidate, checkMail] = useState(false);
    const handleMail = (event) => {
        if(event.target.value){
            checkMail(false);
            mailHelper('必須');
            dispatch(setMail(event.target.value));
        }else{
            checkMail(true);
            mailHelper('メールアドレスは必ずご入力くさだい。');
            dispatch(clearMail());
        }
    }

    const [telephoneValidate, checkTelephone] = useState(false);
    const handleTelephone = (event) => {
        if(event.target.value){
            checkTelephone(false);
            telHelper('必須');
            dispatch(setTelephone(event.target.value));
        }else{
            checkTelephone(true);
            telHelper('電話番号は必ずご入力くさだい。');
            dispatch(clearTelephone());
        }
    }

    const handleAddress = (event) => {
        if(event.target.value){
            dispatch(setAddress(event.target.value));
        }else{
            dispatch(clearAddress());
        }
    }

    const handleMemo = (event) => {
        if(event.target.value){
            dispatch(setMemo(event.target.value));
        }else{
            dispatch(clearMemo());
        }
    }

    const handleTelephoneRequest = (event) => {
        dispatch(setTelephoneRequest(!telephoneRequest));
    }

    const handleMailRequest = (event) => {
        dispatch(setMailRequest(!mailRequest));
    }

    const [open, setOpen] = useState(false);

    const classes = useStyles();

    return(
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <PageExplanation pageName="作成者情報" firstItemName="名前" igonFlag={igonFlag}/>

                    <PageStep activeStep={0}/>

                    <PersonStep activeStep={0}/>

                    <FlowCaution/>

                    <MenuList pageName="作成者情報登録" />

                    <TextField
                        id="author_name"
                        name="author_name"
                        label="名前"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="お名前をフルネームでご入力ください。"
                        helperText={nameHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleName}
                        onChange={handleName}
                        error={nameValidate}
                        value={name}
                    />
                    <TextField
                        id="author_mail"
                        name="author_mail"
                        label="メールアドレス"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="メールアドレスをご入力ください。"
                        helperText={mailHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleMail}
                        onChange={handleMail}
                        error={mailValidate}
                        value={mail}
                    />
                    <TextField
                        id="author_tel"
                        name="author_tel"
                        label="電話番号"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="電話番号をご入力ください。"
                        helperText={telHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleTelephone}
                        onChange={handleTelephone}
                        error={telephoneValidate}
                        value={telephone}
                    />
                    <TextField
                        id="author_address"
                        name="author_address"
                        label="住所"
                        style={{ margin: 8 }}
                        placeholder="ご住所をご入力ください。"
                        helperText="任意"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleAddress}
                        onChange={handleAddress}
                        value={address}
                    />
                    <TextField
                        id="author_memo"
                        name="author_memo"
                        label="ご相談内容"
                        style={{ margin: 8 }}
                        placeholder="ご相談内容をご入力ください。"
                        helperText="任意"
                        fullWidth
                        multiline
                        rows={3}
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleMemo}
                        onChange={handleMemo}
                        value={memo}
                    />

                    <Paper className={classes.explanation}>
                        <Typography>
                            ご相談内容を確認の上、メールまたはお電話でご返答させていただきます。
                        </Typography>
                    </Paper>

                    <Box>
                        <Grid container className={classes.menu} spacing={2}>
                            {
                                (() => {
                                    if(igonFlag){
                                        return(
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" fullWidth onClick={handleAuthor}>自筆証書遺言作成に進む</Button>
                                            </Grid>
                                        );
                                    }else{
                                        return(
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" fullWidth onClick={redirectMoney}>財産目録作成に進む</Button>
                                            </Grid>
                                        );
                                    }
                                })()
                            }
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <FlowTitle title="自筆証書遺言・財産目録の作成の流れをご説明します。" />
                    <FlowItem image="img/icon_person.png" contents="①作成者情報登録<br>まず、作成者情報をご登録ください。" />
                    {
                        (() => {
                            if(igonFlag){
                                return(
                                    <>
                                        <FlowArrow/>
                                        <FlowItemA />
                                    </>
                                );
                            }else{
                                return(
                                    <>
                                        <FlowArrow/>
                                        <FlowItemB />
                                    </>
                                );
                            }
                        })()
                    }
                    <GuideHalf pageName="作成者情報登録"/>
                </Grid>
            </Grid>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={alert} autoHideDuration={3000} onClose={alertClose} message={error}/>
        </Container>
    );
}

export default AuthorWill
